const setG = {

    global: {
        radius: 100,
        lineCount: 200,
        lineWidth: 3,
        length: 1,
        lengthMove: 1,
        offset: .2,
        speed: 0.005,
        spin: 0.005,
        pulse : 0.1,
        hueRange : 0,     
    },

    red: {
        hueBase : 0,    
    },

    yellow: {
        hueBase : 70,    
    },

    green: {
        hueBase : 120,    
    },

    blue: {
        hueBase : 230,    
    },

    purple: {
        hueBase : 280,    
    },

}

export default setG